import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import menuCollapsed from "./module/menu";
import useInfo from "./module/userInfo";
import theme from "./module/theme";
import map from "./module/map";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
export const store = configureStore({
  reducer: {
    menuCollapsed,
    useInfo,
    theme,
    map,
    // map: persistReducer({
    //   key: "mapData",
    //   storage
    // }, map)
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export * from "./module/menu";

// export * from './module/userInfo';

export * from "./module/theme";
